module.exports = __webpack_public_path__ + "img/41.2.TN.f9ae7089.png";